module.exports = "pegasus/assets/tech/safari/101.png";